// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2ucv_","title":"ClientReferral_title__r0FcX","itemText":"ClientReferral_itemText__35iyi"};